import { useSearchParams } from "react-router-dom";

import { RundbogenRechner, StichbogenRechner } from "../components/kalkulation/BogenRechner";
import { ObjektRechner } from "../components/kalkulation/ObjektRechner";
import { Segmente } from "../components/kalkulation/Segmente";
import { TeppichRechner } from "../components/kalkulation/TeppichRechner";

const RECHNER = [
  { id: "stichbogen", label: "Stichbogen", titel: "Stichbogen Insektenschutz", text: "Radius und Bogenlänge aus Sehne und Stich." },
  { id: "rundbogen", label: "Rundbogen", titel: "Rundbogenschiene", text: "Dekolänge der gebogenen Schiene aus einer beliebigen Messsehne." },
  { id: "teppich", label: "Teppich", titel: "Teppichkonfigurator", text: "Preis aus Fläche und Umlauf, je Position und als Summe." },
  { id: "objektkalkulation", label: "Vorhang-Objekt", titel: "Objektkalkulation Stoff & Stange (Excel-Nachbau)", text: "Nachbau der SEDA-Excel: vom Dekometer bis zum Gewinn je Arbeitsstunde, mit Nähauftrag fürs Atelier. Objekte aus allen Konfiguratoren rechnet der Bereich „Objekte“." },
] as const;

/**
 * Demo der Kalkulations-API: jede Eingabe rechnet sofort, Zahlen bewegen sich
 * zum neuen Wert, Zeichnungen lassen sich anfassen. Der gewählte Rechner steht
 * in der URL.
 */
export function KalkulationPage() {
  const [params, setParams] = useSearchParams();
  const aktiv = RECHNER.find((r) => r.id === params.get("rechner")) ?? RECHNER[0];

  return (
    <section className="kalk">
      <div className="page-head">
        <h1>Kalkulation</h1>
        <Segmente segmente={RECHNER.map((r) => ({ id: r.id, label: r.label }))} wert={aktiv.id} onChange={(id) => setParams({ rechner: id })} />
      </div>
      <p className="muted">
        <strong>{aktiv.titel}.</strong> {aktiv.text}
      </p>
      <div className="kalk-inhalt" key={aktiv.id}>
        {aktiv.id === "stichbogen" && <StichbogenRechner />}
        {aktiv.id === "rundbogen" && <RundbogenRechner />}
        {aktiv.id === "teppich" && <TeppichRechner />}
        {aktiv.id === "objektkalkulation" && <ObjektRechner />}
      </div>
    </section>
  );
}
